/* global AppConfig */

import { loadScript } from "_core_framework/move";
import { config } from "./config";

// wrap loadScript in native promise
const loadDeferred = (() => {
  let dfd;

  // to address race condition
  // while promise is pending avoid loading script again
  // if promise is rejected
  // additional calls to this method will try to load the script
  return (url) => {
    if (dfd)
      return dfd;
    else
      return dfd = Promise.resolve(loadScript(url)).catch(() => dfd = undefined);
  };
})();

const mapsApi = AppConfig['google_maps_js_api'];

let callbacks = [];

export const onMapLoad = (fn) => callbacks.push(fn);

const executeCallbacks = (src) => {
  callbacks.forEach((fn) => fn(src));
  callbacks = [];
};

export const loadMaps = (channel) => loadDeferred(googleMapsUrl(channel))
  .then(() => import("./src"))
  .then(executeCallbacks);

const getCredentials = () => {
  if (!config)
    throw "mapConfiguration not set in gon data!";

  const { clientId, apiKey } = config;
  if (clientId)
    return `client=${clientId}`;
  else if (apiKey)
    return `key=${apiKey}`;
  else
    throw "clientId or apiKey is required";
};

const withPrefix = (channel) => {
  if (config.environment)
    return `${config.environment}-${channel}`;
  else
    return channel;
};

const googleMapsUrl = (channel) => {
  if (!channel)
    throw "must specify channel!";

  const creds = getCredentials();

  return `${mapsApi}?v=${config.version}&${creds}&channel=${withPrefix(channel)}`;
};



// WEBPACK FOOTER //
// ./maps/index.js